export enum DispensarizationsReportParameters {
  From = 'From',
  To = 'To',
  ClinicIds = 'ClinicIds',
  BatchIds = 'BatchIds',
  Results = 'Result',
  TextSearch = 'TextSearch',
}
